import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions } from './OpsRampFormOptions';

export const getOpsRampFormData = (target, helpWith) => {
  let namespace: string;
  let subject: string;

  switch (helpWith) {
    case helpWithOptions.flexHybrydObservability:
      namespace = 'hpe_opsramp_flex';
      subject = `OpsRamp : ${helpWith} - {formId}`;
      break;
    case helpWithOptions.standaloneSaaS:
    case helpWithOptions.unknown:
      namespace = 'hpe_opsramp';
      subject = `OpsRamp : {formId}`;
      break;
    default:
      namespace = 'hpe_opsramp';
      subject = `OpsRamp : {formId}`;
      break;
  }

  return getSortedFormFields(target, namespace, subject);
};
